import { render, staticRenderFns } from "./TechnicianCardInfo.vue?vue&type=template&id=040ca9f1"
import script from "./TechnicianCardInfo.vue?vue&type=script&lang=ts"
export * from "./TechnicianCardInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports